import React, { useState, useEffect } from 'react';
import usePostMessage from 'helpers/hooks/useFujifilmNavigation';
import usePath from 'helpers/hooks/usePath';
import { useRouter } from 'i18n/routing';

const channelKey = 'p2r-walmart-us,p2r-cvs-us,p2r-walgreens-us';

interface RetailPickUpProps {
  pickUpToday?: string;
}

export const RetailPickUp: React.FC<RetailPickUpProps> = ({ pickUpToday = 'Pick up as soon as today' }) => {
  const router = useRouter();
  const { pathWithoutQuery } = usePath();
  const [enabled, setEnabled] = useState(false);
  const { postMessageNav } = usePostMessage();
  let rerun = null;
  if (typeof window !== 'undefined') {
    rerun = new URLSearchParams(window.location.search);
  }
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('channelKeys')) {
      localStorage.setItem('pickupassoonastoday', 'true');
      setEnabled(true);
    } else {
      setEnabled(false);
    }
  }, [rerun]);

  const handlePickupSwitch = (push: boolean) => {
    setEnabled(!enabled);
    if (push) {
      const params = new URLSearchParams(window.location.search);
      localStorage.setItem('pickupassoonastoday', 'true');
      params.delete('channelKeys');
      params.append('channelKeys', channelKey);
      router.push(`${pathWithoutQuery}?${params.toString()}`, { scroll: false });
      const currentPath = `${pathWithoutQuery}?${params.toString()}`;
      postMessageNav(currentPath);
    } else {
      localStorage.setItem('pickupassoonastoday', 'false');
      const params = new URLSearchParams(window.location.search);
      params.delete('channelKeys');
      router.push(`${pathWithoutQuery}?${params.toString()}`, { scroll: false });
      const currentPath = `${pathWithoutQuery}?${params.toString()}`;
      postMessageNav(currentPath);
    }
  };

  return (
    <div
      data-testid="retail-pickup-container"
      className="flex lg:min-w-245 items-start gap-3 md:items-center md:space-x-12 md:pl-10"
      data-ffid={`ctr-pickup-today`}
    >
      <button
        aria-label={pickUpToday}
        aria-pressed={enabled}
        data-testid="btn-pickup-checkbox"
        data-ffid={`btn-pickup-checkbox`}
        onClick={() => handlePickupSwitch(!enabled)}
        className={`mr-15 flex h-24 w-60 shrink-0 items-center rounded-full pb-[1.8px] pt-[1.9px] transition-colors duration-300 lg:mr-0 lg:h-24 lg:w-44 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-4 ${enabled ? 'bg-[#018463]' : 'bg-[#5C5C5C]'
          }`}
      >
        <div
          data-testid="pickup-toggle-indicator"
          className={`size-18 ml-1 rounded-full bg-white transition-transform duration-300 lg:size-18  ${enabled ? 'translate-x-35 lg:translate-x-22' :  'translate-x-3'
            }`}
        />
      </button>
      <p
        data-testid="lbl-pickup-today"
        data-ffid={`lbl-pickup-today`}
        className="flex-1 break-words text-16 leading-snug text-[#333333] dark:text-white"
      >
        {pickUpToday}
      </p>
    </div>
  );
};
